// Action Types
export const UPDATE_SHOP = "UPDATE_SHOP";
export const UPDATE_SHOP_BALANCE = "UPDATE_SHOP_BALANCE";

// Action Creator
export const updateShopInRedux = (newShop, newItems, isFakeShop) => ({
    type: UPDATE_SHOP,
    newShop,
    newItems,
    isFakeShop
});

export const updateShopBalance = (balance, abbreviation) => ({
    type: UPDATE_SHOP_BALANCE,
    balance,
    abbreviation
});
